import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { ButtonProps } from "@circle-react-shared/uikit/Button";
import { Button } from "@circle-react-shared/uikit/Button";

interface SaveButtonProps extends ButtonProps {
  label?: string;
}

export const SaveButton = ({ className, label, ...rest }: SaveButtonProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const { onSave, pages, canvasTheme } = useBuilderStore(state => ({
    onSave: state.onSave,
    pages: state.pages,
    canvasTheme: state.currentCanvasTheme,
  }));

  const getLabel = () => {
    if (isSaving) return t("saving");
    if (label) return label;
    return t("save");
  };
  return (
    <Button
      variant="circle"
      className={className}
      disabled={isSaving}
      onClick={async () => {
        setIsSaving(true);
        try {
          await onSave(pages, canvasTheme);
        } finally {
          setIsSaving(false);
        }
      }}
      {...rest}
    >
      {getLabel()}
    </Button>
  );
};
